export enum FulfillmentStepType {
  Delivery = "Delivery",
  Operation = "Operation"
}
